import { Instant } from "@js-joda/core";
import FlipClockCountdown from "@leenguyen/react-flip-clock-countdown";
import "@leenguyen/react-flip-clock-countdown/dist/index.css";
import React from "react";

export default function FlipClock(props: { to: Instant; color: string; onComplete?: () => void }) {
  const epochMillis = React.useMemo(() => props.to.toEpochMilli(), [props.to]);

  return (
    <FlipClockCountdown
      to={epochMillis}
      onComplete={props.onComplete}
      digitBlockStyle={{
        width: 24,
        height: 36,
        fontSize: 16,
        backgroundColor: props.color,
        boxShadow: "none",
      }}
      labelStyle={{ color: props.color }}
      separatorStyle={{ color: props.color }}
      dividerStyle={{ height: 0 }}
    />
  );
}
